export default {"src":"/_next/static/media/0xb12bfca5a55806aaf64e99521918a4bf0fc40802.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};